<template>
  <div>
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          fill-rule="evenodd"
          clip-rule="evenodd" d="M20.0654 9.93747L22.6354 10.3566C22.8458 10.3907 23.0003 10.5726 23 10.7858V13.1773C23 13.3885 22.8483 13.5691 22.6404 13.6057L20.0671 14.0575C19.9184 14.5725 19.7131 15.0696 19.4552 15.5395L20.9757 17.6511C21.1003 17.8241 21.0811 18.0619 20.9304 18.2128L19.2397 19.9044C19.0905 20.0541 18.8552 20.0746 18.6823 19.953L16.5499 18.4567C16.0775 18.7191 15.5773 18.9283 15.0587 19.0803L14.6044 21.6412C14.5677 21.8487 14.3875 21.9999 14.1769 22H11.7846C11.5722 22.0003 11.3908 21.8467 11.3562 21.637L10.9321 19.0887C10.4115 18.9382 9.90905 18.7305 9.4342 18.4693L7.31685 19.953C7.14409 20.0738 6.90947 20.0533 6.76027 19.9044L5.06957 18.2128C4.91945 18.0621 4.9 17.8251 5.02347 17.652L6.5197 15.5563C6.25599 15.0795 6.04627 14.5749 5.89438 14.0516L3.35876 13.6023C3.15239 13.5656 3.00159 13.3869 3 13.1773V10.7866C3.00042 10.5741 3.15423 10.3931 3.36379 10.3583L5.89941 9.93914C6.05155 9.41599 6.26127 8.91135 6.52473 8.43447L5.04694 6.32038C4.92582 6.1477 4.94627 5.9129 5.09556 5.76378L6.78541 4.07385C6.93588 3.92338 7.17318 3.90385 7.34619 4.02775L9.44593 5.52068C9.91995 5.26166 10.4212 5.05587 10.9405 4.90708L11.3596 2.36213C11.3949 2.15441 11.5739 2.00193 11.7846 2H14.176C14.3872 2 14.5677 2.15172 14.6044 2.35961L15.0528 4.91881C15.5716 5.0697 16.072 5.27776 16.5448 5.53913L18.6505 4.02523C18.8235 3.90067 19.0613 3.91986 19.2121 4.0705L20.9028 5.76043C21.0521 5.9098 21.0727 6.14494 20.9514 6.31787L19.451 8.45543C19.7091 8.92561 19.9152 9.42252 20.0654 9.93747ZM9.95725 12.0004C9.95675 13.6814 11.3191 15.0445 13 15.045C14.6809 15.0454 16.0439 13.6831 16.0444 12.0021C16.0448 10.3211 14.6826 8.95805 13.0017 8.95754H13C11.3197 8.95805 9.95775 10.32 9.95725 12.0004Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiSettings',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>